import { ArrangementType, GuidedComparisonType } from '../models/enums';
import { ChannelType } from '../models/ichannel';

const traceSpacing = 0.3;
const studiesSpacing = 0.15;
const horizontalStudiesSpacing = 0;
const HORIZONTAL_STUDIES_SPACING_12X1 = 2.75;

export const ECG_CONSTANTS = {
    PAPER_OPACITY: 0.3,

    LEAD_WIDTH_25mm: 250,
    LEAD_WIDTH_50mm: 500,
    LEAD_HEIGHT: 100,

    LEAD_SPACE_WIDTH: 30,

    MAX_POSITIVE_MICROVOLT_VALUE: 5000,

    MIN_ZOOM_FACTOR: 1,
    MAX_ZOOM_FACTOR: 15,

    VIEW_BOX: '',

    TRACE_ROWS: 6,
    TRACE_COLUMNS: 2,

    CHANNELS_STANDARD_ORDER: [
        ChannelType.LEAD_I,
        ChannelType.LEAD_II,
        ChannelType.LEAD_III,
        ChannelType.LEAD_AVR,
        ChannelType.LEAD_AVL,
        ChannelType.LEAD_AVF,
    ],
    CHANNELS_CABRERA_ORDER: [
        ChannelType.LEAD_AVL,
        ChannelType.LEAD_I,
        ChannelType.LEAD_AVR,
        ChannelType.LEAD_II,
        ChannelType.LEAD_AVF,
        ChannelType.LEAD_III,
    ],

    TRACE_SPACING: traceSpacing,
    STUDIES_SPACING: studiesSpacing,
    STUDIES_SPACING_12X1: 0,

    HORIZONTAL_STUDIES_SPACING: horizontalStudiesSpacing,
    HORIZONTAL_STUDIES_SPACING_12X1: HORIZONTAL_STUDIES_SPACING_12X1,

    GUIDED_COMPARISON_TRACE_SPACING: [traceSpacing, 0.3, 0.15, traceSpacing], // TraceToTrace, Overlapping, ExamToExam (sliderFactor = 100)
    GUIDED_COMPARISON_STUDIES_SPACING: [studiesSpacing, 0, 0.9, horizontalStudiesSpacing], // TraceToTrace, Overlapping, ExamToExam (sliderFactor = 100)
    //@TODO il valore corrispondente al caso esame per esame non puo essere statico perche dipende anche dal tipo di visualizzazione
    GUIDED_COMPARISON_STUDIES_HORIZONTAL_SPACING: [horizontalStudiesSpacing, 0, 0, HORIZONTAL_STUDIES_SPACING_12X1], // TraceToTrace, Overlapping, ExamToExam (sliderFactor = 100)

    defaultComparisonByArrangement: {
        [ArrangementType.SixXTwo]: GuidedComparisonType.TraceToTrace,
        [ArrangementType.Medians]: GuidedComparisonType.TraceToTrace,
        [ArrangementType.SixXOnePeripheral]: GuidedComparisonType.TraceToTrace,
        [ArrangementType.XXOne]: GuidedComparisonType.TraceToTrace,
        [ArrangementType.XXTwo]: GuidedComparisonType.TraceToTrace,
        [ArrangementType.SixXOnePrecordial]: GuidedComparisonType.TraceToTrace,
        [ArrangementType.ThreeXFour]: GuidedComparisonType.TraceToTrace,
        [ArrangementType.TwelveXOne]: GuidedComparisonType.SideBySide,
    } as Record<ArrangementType, GuidedComparisonType>,
};

/* export class ECG_CONSTANTS {
    static PAPER_OPACITY = 0.3;

    static LEAD_WIDTH_25mm = 250;
    static LEAD_WIDTH_50mm = 500;
    static LEAD_HEIGHT = 100;

    static LEAD_SPACE_WIDTH = 30;

    static MAX_POSITIVE_MICROVOLT_VALUE = 5000;

    static MIN_ZOOM_FACTOR = 1;
    static MAX_ZOOM_FACTOR = 15;

    static VIEW_BOX = '';

    static TRACE_ROWS = 6;
    static TRACE_COLUMNS = 2;

    static CHANNELS_STANDARD_ORDER = [
        ChannelType.LEAD_I,
        ChannelType.LEAD_II,
        ChannelType.LEAD_III,
        ChannelType.LEAD_AVR,
        ChannelType.LEAD_AVL,
        ChannelType.LEAD_AVF,
    ];
    static CHANNELS_CABRERA_ORDER = [
        ChannelType.LEAD_AVL,
        ChannelType.LEAD_I,
        ChannelType.LEAD_AVR,
        ChannelType.LEAD_II,
        ChannelType.LEAD_AVF,
        ChannelType.LEAD_III,
    ];

    static TRACE_SPACING = 0.3;
    static STUDIES_SPACING = 0.15;
    static STUDIES_SPACING_12X1 = 0;

    static HORIZONTAL_STUDIES_SPACING = 0;
    static HORIZONTAL_STUDIES_SPACING_12X1 = 2.75;

    static GUIDED_COMPARISON_TRACE_SPACING = [ECG_CONSTANTS.TRACE_SPACING, 0.3, 0.15, ECG_CONSTANTS.TRACE_SPACING]; // TraceToTrace, Overlapping, ExamToExam (sliderFactor = 100)
    static GUIDED_COMPARISON_STUDIES_SPACING = [
        ECG_CONSTANTS.STUDIES_SPACING,
        0,
        0.9,
        ECG_CONSTANTS.HORIZONTAL_STUDIES_SPACING,
    ]; // TraceToTrace, Overlapping, ExamToExam (sliderFactor = 100)
    //@TODO il valore corrispondente al caso esame per esame non puo essere statico perche dipende anche dal tipo di visualizzazione
    static GUIDED_COMPARISON_STUDIES_HORIZONTAL_SPACING = [
        ECG_CONSTANTS.HORIZONTAL_STUDIES_SPACING,
        0,
        0,
        ECG_CONSTANTS.HORIZONTAL_STUDIES_SPACING_12X1,
    ]; // TraceToTrace, Overlapping, ExamToExam (sliderFactor = 100)

    static defaultComparisonByArrangement: Record<ArrangementType, GuidedComparisonType> = {
        [ArrangementType.SixXTwo]: GuidedComparisonType.TraceToTrace,
        [ArrangementType.Medians]: GuidedComparisonType.TraceToTrace,
        [ArrangementType.SixXOnePeripheral]: GuidedComparisonType.TraceToTrace,
        [ArrangementType.XXOne]: GuidedComparisonType.TraceToTrace,
        [ArrangementType.XXTwo]: GuidedComparisonType.TraceToTrace,
        [ArrangementType.SixXOnePrecordial]: GuidedComparisonType.TraceToTrace,
        [ArrangementType.ThreeXFour]: GuidedComparisonType.TraceToTrace,
        [ArrangementType.TwelveXOne]: GuidedComparisonType.SideBySide,
    };
}
 */
